import {RosterEmployment, Resource, Roster, RosterUser} from '@cquential/api';

export default class ResourceEmploymentDeduplicator {
    public static deduplicateOnRoster(roster: Roster): void {
        const employments: Record<number, RosterEmployment> = {};
        const users: Record<string, RosterUser> = {};
        const allResources: Resource[] = (roster.resources ?? []).concat(roster.relatedResources ?? []).concat(roster.resourcesFromOtherRosters ?? []);

        for (const resource of allResources) {
            if (resource.employmentId in employments) {
                // already encountered in earlier iteration, so add link between that earlier employment and this resource, both directions
                employments[resource.employmentId].resources!.push(resource);
                resource.employment = employments[resource.employmentId];
            } else if (resource.employment) {
                employments[resource.employmentId] = resource.employment;
                if (resource.employment.resources === undefined) {
                    resource.employment.resources = [];
                }
                employments[resource.employmentId].resources!.push(resource);
            }
        }

        for (const employment of Object.values(employments)) {
            if (employment.user && employment.user.username in users) {
                // already encountered in earlier iteration, so add link between that earlier user and this employment, both directions
                users[employment.user.username].employments!.push(employment);
                employment.user = users[employment.user.username];
            } else if (employment.user) {
                users[employment.user.username] = employment.user;
                if (employment.user.employments === undefined) {
                    employment.user.employments = [];
                }
                employment.user.employments!.push(employment);
            }
        }
    }
}
